import { render, staticRenderFns } from "./pagina.vue?vue&type=template&id=6399c077&"
import script from "./pagina.vue?vue&type=script&lang=js&"
export * from "./pagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports